import { render, staticRenderFns } from "./WeightSidebar.vue?vue&type=template&id=fba080a4&"
import script from "./WeightSidebar.vue?vue&type=script&lang=js&"
export * from "./WeightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fba080a4')) {
      api.createRecord('fba080a4', component.options)
    } else {
      api.reload('fba080a4', component.options)
    }
    module.hot.accept("./WeightSidebar.vue?vue&type=template&id=fba080a4&", function () {
      api.rerender('fba080a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/WeightSidebar.vue"
export default component.exports